import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { switchUserRole, fetchUserList } from "app/services/user/user.service";
import { BASE_URL } from "static/constants";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: ({ mutation, query }) => ({
    switchRole: mutation({
      queryFn: (payload) => {
        return { data: switchUserRole(payload) };
      },
    }),
    getUsers: query({
      queryFn: () => {
        return { data: fetchUserList() };
      },
    }),
  }),
});

export const { useSwitchRoleMutation, useGetUsersQuery } = userApi;
